/**
 * Global v-file-dropzone directive
 * Enables drag-and-drop file upload on any container or input element.
 * Adds 'is-dragover' class on dragover, and populates the inner file input or invokes callback on drop.
 */
export default {
  bind(el, binding) {
    let dragCounter = 0;

    el._onDragEnter = function(e) {
      e.preventDefault();
      dragCounter++;
      el.classList.add("is-dragover");
    };

    el._onDragOver = function(e) {
      e.preventDefault();
      if (!el.classList.contains("is-dragover")) {
        el.classList.add("is-dragover");
      }
    };

    el._onDragLeave = function(e) {
      e.preventDefault();
      dragCounter--;
      if (dragCounter <= 0) {
        dragCounter = 0;
        el.classList.remove("is-dragover");
      }
    };

    el._onDrop = function(e) {
      e.preventDefault();
      dragCounter = 0;
      el.classList.remove("is-dragover");

      const files = e.dataTransfer && e.dataTransfer.files;
      if (!files || files.length === 0) return;

      // Find file input on or inside el
      const fileInput =
        el.tagName === "INPUT" && el.type === "file"
          ? el
          : el.querySelector('input[type="file"]');

      if (fileInput) {
        try {
          fileInput.files = files;
          fileInput.dispatchEvent(new Event("change", { bubbles: true }));
        } catch (err) {
          // In environments where setting input.files directly is restricted
        }
      }

      if (typeof binding.value === "function") {
        binding.value(files, e);
      }
    };

    el.addEventListener("dragenter", el._onDragEnter);
    el.addEventListener("dragover", el._onDragOver);
    el.addEventListener("dragleave", el._onDragLeave);
    el.addEventListener("drop", el._onDrop);
  },

  unbind(el) {
    if (el._onDragEnter) el.removeEventListener("dragenter", el._onDragEnter);
    if (el._onDragOver) el.removeEventListener("dragover", el._onDragOver);
    if (el._onDragLeave) el.removeEventListener("dragleave", el._onDragLeave);
    if (el._onDrop) el.removeEventListener("drop", el._onDrop);
    delete el._onDragEnter;
    delete el._onDragOver;
    delete el._onDragLeave;
    delete el._onDrop;
  }
};
